'use client';
import { rem } from '../../../../utils/units-converters/rem.mjs';
import 'react';

function sizeResolver(value) {
  if (typeof value === "number") {
    return rem(value);
  }
  return value;
}

export { sizeResolver };
//# sourceMappingURL=size-resolver.mjs.map
